import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/gdc/projects',
          role: 'access_gdc',
        },
        gasguajira: {
          path: '/gdg/projects',
          role: 'access_gdg',
        },
        efigas: {
          path: '/efg/projects',
          role: 'access_efg',
        },
      }}
    />
  );
};

export default Home;
